// Turkish dotted/dotless i do not fold to the same character with toLowerCase().
// İ (U+0130) becomes "i" + combining dot, so "ilk" misses "İlk Yarı".
const foldCase = (value) =>
    (value ?? '')
        .toString()
        .replace(/\u0130/g, 'i')
        .replace(/\u0049/g, 'i')
        .replace(/\u0131/g, 'i')
        .toLowerCase()
        .replace(/\u0307/g, '');

const caseInsensitiveRegExp = (value) => {
    const pattern = (value ?? '')
        .toString()
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/[iİIı]/g, '[iİIı]');

    return new RegExp(pattern, 'gi');
};

export {foldCase, caseInsensitiveRegExp};
